import React, {useEffect,useRef,useState} from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Card, Button} from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { HashLink } from 'react-router-hash-link';
import '../App.css'; 
import Request from './Request';
import ImageCarouselInicio from "./ImageCarouselInicio";
import ModalRequest from './ModalRequest'

import calidad from '../assets/Inicio/servicio premium seguridad privada.png'
import monitoreo1 from '../assets/Inicio/Seguridad privada en buenos aires.jpg'
import empresas from '../assets/Inicio/Seguridad privada y vigilancia para empresas e industrias.jpg'
import barrio from '../assets/Inicio/barrio cerrado.jpg'
import edificios from '../assets/Inicio/Seguridad privada y vigilancia para edificion y centros comerciales.jpg'
import videoBackground from '../assets/Inicio/Video-de-Lucas-Armat-Mkt.mp4';
import videoBackground2 from '../assets/Inicio/portada 2 Gif Julian.webm';
import videoBackground3 from '../assets/Inicio/Portada Gif ArmatControl p web.webm';
import habilitacionProv from '../assets/Inicio/Empresa de seguridad habilitada en provincia de Bs As Buenos aires.jpeg';
import habilitacionCABA from '../assets/Inicio/Empresa de seguridad habilitada en Caba Capital Federal.png';
import bannerArmatControl from '../assets/banner-armat-control.jpeg';

const Inicio = () => {


  function Titulo() {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <h2
      ref={ref}
      className={`titulo-animado ${visible ? "visible" : ""} green-tittle text-center text-break font-italic mb-3 sinergia-animado`}
    >
      Sinergia Estratégica: ARMAT03 & RHF Management
    </h2>
  );
}


  const IconoFlecha = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      className="icono-flecha"
      >
      <path d="M246.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L178.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C47.63 444.9 55.81 448 64 448s16.38-3.125 22.62-9.375l160-160C259.1 266.1 259.1 245.9 246.6 233.4zM438.6 233.4l-160-160c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L370.8 256l-137.4 137.4c-12.5 12.5-12.5 32.75 0 45.25C239.6 444.9 247.8 448 256 448s16.38-3.125 22.62-9.375l160-160C451.1 266.1 451.1 245.9 438.6 233.4z"></path>
    </svg>
  );


  const tarjetas = [
    { id: 'empresas', src: empresas, title: 'SEGURIDAD PARA EMPRESAS' },
    { id: 'barrio-cerrado', src: barrio, title: 'SEGURIDAD PARA BARRIOS' },
    { id: 'edificios', src: edificios, title: 'SEGURIDAD PARA EDIFICIOS' },
  ];
  

  //////////////////////////////////////

  const isSmallScreen = useMediaQuery({ maxWidth: 1078 });
  const isSmallScreen2 = useMediaQuery({ maxWidth: 767 });
  const isSmallScreen3 = useMediaQuery({ maxWidth: 1078, minWidth: 895 });

  const fondosInicio = [
    { tipo: 'video', src: videoBackground },
    { tipo: 'video', src: videoBackground2 },
    { tipo: 'video', src: videoBackground3, clase: 'fondo-control' },
  ];
  const [slide, setSlide] = useState(0);

  const bannerRef = useRef(null);
  const [bannerVisible, setBannerVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setBannerVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    observer.observe(bannerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setSlide((slide + 1) % fondosInicio.length), 8000);
    return () => clearTimeout(timer);
  }, [slide, fondosInicio.length]);



  return (
    <>
    <Helmet>
        <title>Empresa de Seguridad Privada en Buenos Aires | Armat03</title>
        <meta name="description" content="Empresa de seguridad privada en Buenos Aires. Servicios de vigilancia, control de accesos y soluciones de seguridad para empresas, industrias y barrios." />
    </Helmet>

    <Container fluid className="security-section overlay2">
      
      <video src={videoBackground3} autoPlay loop muted playsInline aria-hidden="true" className={`background-video fondo-slide fondo-control-blur ${slide === 2 ? 'activo' : ''}`} />
      {fondosInicio.map((fondo, i) =>
        fondo.tipo === 'video' ? (
          <video key={i} src={fondo.src} autoPlay loop muted playsInline className={`background-video fondo-slide ${fondo.clase || ''} ${slide === i ? 'activo' : ''}`} />
        ) : (
          <img key={i} src={fondo.src} alt="" className={`background-video fondo-slide ${slide === i ? 'activo' : ''}`} />
        )
      )}

      <button
        type="button"
        className="flecha-inicio izquierda"
        aria-label="Diapositiva anterior"
        onClick={() => setSlide((slide - 1 + fondosInicio.length) % fondosInicio.length)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 6l-6 6l6 6" /></svg>
      </button>
      <button
        type="button"
        className="flecha-inicio derecha"
        aria-label="Diapositiva siguiente"
        onClick={() => setSlide((slide + 1) % fondosInicio.length)}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6l-6 6" /></svg>
      </button>

      <HashLink
        to="/ArmatControl"
        className={`btn btn-success boton-slide-control ${slide === 2 ? 'visible' : ''}`}
        tabIndex={slide === 2 ? 0 : -1}
      >CONOCER MÁS
      </HashLink>

      <div className="indicadores-inicio">
        {fondosInicio.map((_, i) => (
          <button
            key={i}
            type="button"
            aria-label={`Ir a la diapositiva ${i + 1}`}
            className={slide === i ? 'activo' : ''}
            onClick={() => setSlide(i)}
          />
        ))}
      </div>

      <Row className="align-items-center px-3 py-5 justify-content-center ">
        <Col md={12} lg={6} xs={12} className={`text-content text-lg-start text-sm-center texto-slide ${slide === 2 ? 'oculto' : ''}`}>
          <div>
            <h1 className="titulo-inicio">
              Seguridad<br />a tu medida
            </h1>

          </div>
          {/*<div className="d-flex flex-wrap justify-content-lg-start justify-content-sm-center aling-items-center boxs ">
            <img src={seguridad} alt="" className="logo-inicio mx-2 box" />
          </div>
            <div className="d-flex flex-wrap justify-content-lg-start mb-4 justify-content-sm-center aling-items-center boxs ">
              <img src={a} alt="" className="logo-inicio mx-2 box" />
              <img src={tu} alt="" className="logo-inicio mx-2 box" />
              <img src={medida} alt="" className="logo-inicio mx-2 box" />
            </div>*/}
          {/*
          <h3>Cuando se trata de fiabilidad, somos lo que necesitás!</h3>
          */}
          <p className="text-white font-protegemos-empresas">Protegemos empresas, industrias y barrios privados con soluciones de seguridad adaptadas a cada necesidad</p>
        </Col>

        <Col md={12} lg={6} xs={12} className="form-content text-center justify-content-center">
        <div className=''>
          <h2 className="text-white text-break">ENVIANOS TU CONSULTA</h2>
          <h5 className="mb-4 text-break text-start font-contanos">Contanos qué necesitas y te contactamos a la brevedad.</h5>
          <Request />
          <div>
              <hr className="divider-request2 my-4" />
          </div>
          <div className="d-flex align-items-center justify-content-center flex-wrap">
              <p className="text-white mb-2" style={{ fontSize: '19px'}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none" stroke="#8CFFBE" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-briefcase me-2" style={{ verticalAlign: '-0.2em' }}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -9" /><path d="M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2" /><path d="M12 12l0 .01" /><path d="M3 13a20 20 0 0 0 18 0" /></svg>
                ¿Querés formar parte de nuestro equipo?
              </p>
              <Button
                variant="outline-success"
                size="m"
                className="m-0 px-5 py-3"
                style={{ minWidth: '340px', borderWidth: '2px' }}
                href={`mailto:cv.rrhh@armatseguridad.com?subject=${encodeURIComponent('Envío de CV')}`}
              >
                <b className="text-white">ENVIÁ TU CV</b>
              </Button>
            </div>
          </div>
        </Col>
      </Row>      
    </Container>

    <Container fluid className="nosotros-section" >


      {isSmallScreen2 ?(
        <div className="py-4">
          <Row className="align-items-stretch ">
            <Col md={3} sm={12} className="d-flex ">
              <Row className="flex-grow-1 w-100 h-100 g-0 ">
                <Col md={12} sm={6} className="d-flex align-items-center justify-content-center">
                  <img className='img-fluid'  src={habilitacionProv} alt="Empresa de seguridad habilitada en provincia de Bs As Buenos aires"/>
                </Col>
                <Col md={12} sm={6} className="d-flex align-items-center justify-content-center">
                  <img className='img-fluid hab-caba'  src={habilitacionCABA} alt="Empresa de seguridad habilitada en Caba Capital Federal"/>
                </Col>
              </Row>
            </Col>

            <Col md={9} sm={12} className="d-flex align-items-start justify-content-start h-100 ">
              <div className="d-flex flex-column justify-content-center h-100 w-100">
              <p className='text-white habilitacion text-justify-custom flex-grow-1 mb-0'>
                En Armat03 prestamos servicios para la protección de personas y bienes en todos los entornos. Nuestra amplia experiencia, funcionamiento seguro y respuesta integral están garantizados por un equipo de profesionales comprometidos con la calidad y la innovación en todos los niveles.
              <br/>
              <br/>
                ARMAT03 SRL está registrada bajo la Ley de Seguridad Privada N° 12.297 y N° 5.688 del Ministerio de Seguridad de la Provincia de Buenos Aires, así como en la Dirección General de Seguridad Privada y Custodia de Bienes de la Ciudad Autónoma de Buenos Aires. Esto garantiza que cumplimos con todas las normativas legales y ofrecemos un servicio de seguridad confiable y acorde a la ley.
              </p>
              </div>
            </Col>
          </Row>
        </div> ) : (
        <div className="py-4">
          <Row className="">
            <Col md={2} className="">
              <div className='d-flex justify-content-end'>              
              <img className='img-fluid mb-2' style={{maxWidth:"85%"}} src={habilitacionProv} alt="Empresa de seguridad habilitada en provincia de Bs As Buenos aires"/>
              </div>
              <div className='d-flex justify-content-end'>              
              <img className='img-fluid' style={{maxWidth:"85%"}} src={habilitacionCABA} alt="Empresa de seguridad habilitada en provincia de Bs As Buenos aires"/>
            </div>
            </Col>
            
            <Col md={10} className="" >
              <div className="d-flex flex-column justify-content-center" style={{maxWidth:"100%"}}>
                <p className='text-white text-justify-custom habilitacion-md'>
                  En Armat03 prestamos servicios para la protección de personas y bienes en todos los entornos. Nuestra amplia experiencia, funcionamiento seguro y respuesta integral están garantizados por un equipo de profesionales comprometidos con la calidad y la innovación en todos los niveles.
                <br/>
                <br/>
                  ARMAT03 SRL está registrada bajo la Ley de Seguridad Privada N° 12.297 y N° 5.688 del Ministerio de Seguridad de la Provincia de Buenos Aires, así como en la Dirección General de Seguridad Privada y Custodia de Bienes de la Ciudad Autónoma de Buenos Aires. Esto garantiza que cumplimos con todas las normativas legales y ofrecemos un servicio de seguridad confiable y acorde a la ley.
                </p>
              </div>
            </Col>
          </Row>       
               
        </div>
        )}     
      
      <Container>
        <hr className='text-center divider-inicio'/> 
      </Container>

      {isSmallScreen ?(
      <Row className="align-items-start justify-content-center mb-5 py-5 mx-2"> 
        <Col lg={5} md={5}  xs={12} sm={12} className="d-flex justify-content-center ">
          <img src={monitoreo1} alt="Monitoreo" className="img-fluid mb-3" style={{ maxHeight: '650px', objectFit: 'cover' }} />
        </Col>
        <Col lg={7} md={7} xs={12} sm={12} className="text-center text-md-start ">
          <h2 className='text-white pb-3'>Aspiramos a la excelencia en nuestro trabajo</h2>
          <ul className=''> 
            <li className='text-white items-aspiramos '><IconoFlecha/>Soluciones a la medida de cada cliente</li>
            <li className='text-white items-aspiramos'><IconoFlecha/>Supervisión remota y presencial</li>
            <li className='text-white items-aspiramos'><IconoFlecha/>Prestamos servicio de inmediato</li>            
          </ul>    
          <div className="d-grid gap-2 mb-4"><ModalRequest/></div>
          {isSmallScreen3 ? <div className="d-flex justify-content-center" ><img src={calidad} alt="servicio premium seguridad privada" className="img-fluid " style={{width:"34%"}}/></div> : null}
         
        </Col>
        <div sm={12} className="py-5" >
          <Row  className="g-3 justify-content-center">
            {tarjetas.map((card, index) => (
              <Col key={index} md={4}className="d-flex justify-content-center">
                <Card className="text-white " style={{ maxWidth: '350px', minHeight: '200px' }}>
                  <Card.Img src={card.src} alt={card.title} className="" />
                  <Card.ImgOverlay className="d-flex flex-column justify-content-center align-items-center">
                    <Card.Title className="mb-3 text-center">{card.title}</Card.Title>
                    <HashLink to={`/servicios#${card.id}`} className="btn btn-success" >
                      CONOCER SERVICIO</HashLink>
                  </Card.ImgOverlay>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Row>

      ) : (
      <Row className="align-items-start justify-content-center mb-5 py-5 mx-2 "> 
        <Col md={5}  xs={12} sm={12} className="d-flex justify-content-center col-dinamica1">
          <img src={monitoreo1} alt="Monitoreo" className="img-fluid" style={{ maxHeight: '650px', objectFit: 'cover' }} />
        </Col>
        <Col md={7} xs={12} sm={12} className="text-center text-md-start col-dinamica2">
          <Row className="d-flex justify-content-center align-items-center"> 
            <h2 className='text-white pb-3' style={{marginLeft:"9%"}}>Aspiramos a la excelencia en nuestro trabajo</h2>
            <Col md={7} > 
              <ul className='mt-1' style={{marginLeft:"9%"}}> 
                <li className='text-white items-aspiramos'><IconoFlecha/>Soluciones a la medida de cada cliente</li>
                <li className='text-white items-aspiramos'><IconoFlecha/>Supervisión remota y presencial</li>
                <li className='text-white items-aspiramos'><IconoFlecha/>Prestamos servicio de inmediato</li>
              </ul>
            </Col>
            <Col md={5} className='text-end'>
              <img src={calidad} alt="servicio premium seguridad privada" className="img-fluid d-flex justify-content-center" style={{width:"150px"}}/>
            </Col>
          </Row>
          <div sm={12} className="pb-5 d-flex justify-content-start" >
            <Row  className="g-3 justify-content-center">
              <Col xs={12} className="d-grid text-center"><ModalRequest/></Col>
              {tarjetas.map((card, index) => (
                <Col key={index} md={4}className="d-flex justify-content-center">
                  <Card className="text-white " style={{ maxWidth: '350px', minHeight: '200px' }}>
                    <Card.Img src={card.src} alt={card.title} className="" />
                    <Card.ImgOverlay className="d-flex flex-column justify-content-center align-items-center">
                      <Card.Title className="mb-3 text-center">{card.title}</Card.Title>
                      <HashLink to={`/servicios#${card.id}`} className="btn btn-success"  >
                        CONOCER SERVICIO</HashLink>
                    </Card.ImgOverlay>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
      )
      }
      
    </Container> 
    <Container fluid style={{ backgroundColor: 'white' }} className='pb-5'>
      <h1 className="d-flex justify-content-center text-black text-center pt-1 pb-3">
        CLIENTES QUE CONFIAN EN NOSOTROS
      </h1>
      <div className="text-center container">
        <ImageCarouselInicio/>
      </div>
    </Container>

    <section className="banner-armat" ref={bannerRef}>
      <Container fluid className="px-4 px-lg-5">
        <Row className="align-items-center">
          <Col lg={6} className="py-4">
            <p className="banner-armat__novedad">NOVEDAD</p>
            <h2 className="banner-armat__titulo">
              Creamos una <b>nueva plataforma</b><br />
              <span>de control de accesos</span>
            </h2>
            <p className="banner-armat__texto">
              Armat Control es una solución creada por Armat03 para registrar ingresos de forma óptima, mejorar la gestión y brindar mayor trazabilidad en tiempo real.
            </p>
            <Button className="banner-armat__boton" href="/ArmatControl">
              CONOCÉ ARMAT CONTROL
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ms-3"><path d="M9 6l6 6l-6 6" /></svg>
            </Button>
          </Col>
          <Col lg={6} className="py-4">
            <img
              src={bannerArmatControl}
              alt="Logo de Armat Control"
              className={`banner-armat__logo ${bannerVisible ? 'visible' : ''}`}
            />
          </Col>
        </Row>
      </Container>
    </section>
  
    </>
  );
};

export default Inicio;
